import { Metadata } from 'next'

const title = 'How to Ship Luggage, Boxes, and More | Ship&Play'
const description =
  'Learn how to book, pack, and label your luggage, boxes, and sports equipment for ' +
  "shipping ahead with Ship&Play. Spoiler: it's super easy."
const url = 'https://www.shipplay.com/how-it-works'
const image = 'https://media.shipplay.com/ship-sticks-og-image.png'

const metadata: Metadata = {
  title,
  description,
  alternates: {
    canonical: url,
  },
  openGraph: {
    type: 'website',
    url,
    siteName: 'Ship&Play',
    title,
    description,
    images: [
      {
        url: image,
        width: 1200,
        height: 630,
        alt: 'How to ship luggage, boxes, and more with Ship&Play',
      },
    ],
  },
  twitter: {
    card: 'summary_large_image',
    title,
    description,
    images: [image],
  },
}

export default metadata
